import { render, staticRenderFns } from "./CartFavouritesIcon.vue?vue&type=template&id=b2154e24&"
import script from "./CartFavouritesIcon.vue?vue&type=script&lang=js&"
export * from "./CartFavouritesIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports